module.exports = __webpack_public_path__ + "e8afa68920b49e5b4afe84194c19a454.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-29.png
// module id = 2264
// module chunks = 0